<h1 *ngIf="context.data"
    matDialogTitle
    translate>
    license_modal_update_no_internet_title
</h1>

<mat-dialog-content>
    <p>
        <ng-container *ngIf="!context.data; else alt">
            {{ 'license_modal_update_description' | translate }}
        </ng-container>
        <ng-template #alt>
            {{ 'license_modal_update_no_internet_description' | translate }}
        </ng-template>
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_cancel' | translate }}
    </button>
    <button [hidden]="context.data"
            (click)="online()"
            mat-button
            type="button"
            color="primary">
        {{ 'modal_action_online' | translate }}
    </button>
    <button (click)="offline()"
            mat-button
            type="button"
            color="primary">
        <ng-container *ngIf="!context.data; else altBtn">
            {{ 'modal_action_offline' | translate }}
        </ng-container>
        <ng-template #altBtn>
            {{ 'modal_action_activate_offline' | translate }}
        </ng-template>
    </button>
</mat-dialog-actions>
